import WonOffers from './won-offers';

export default WonOffers;
